<script lang="ts">
  export let src: string;
  export let alt: string;
  export let height: number;
  export let width: number;
</script>

<img {src} {alt} {height} {width} class="w-full h-auto" />
